import Vue from 'vue';

//helper app
import './Components/Helpers/HelperComponent';

/**
 * all component of GUD
 */
Vue.component('personal-information', require('./Components/Views/Auth/PersonalInformation').default);
Vue.component('company-information', require('./Components/Views/Auth/CompanyInformation').default);
Vue.component('certificate-profile', require('./Components/Views/Auth/certificate').default);
Vue.component('company-logo', require('./Components/Views/Auth/compnayinformation/logo').default);
Vue.component('company-seal', require('./Components/Views/Auth/compnayinformation/seal').default);
Vue.component('company-banner', require('./Components/Views/Auth/compnayinformation/banner').default);
Vue.component('company-info', require('./Components/Views/Auth/compnayinformation/companyinfo').default);
Vue.component('membership-info', require('./Components/Views/Auth/MembershipInfo').default);
Vue.component('company-gallery', require('./Components/Views/Auth/compnayinformation/gallery').default);
Vue.component('company-about', require('./Components/Views/Auth/compnayinformation/about').default);
Vue.component('company-organogram', require('./Components/Views/Auth/compnayinformation/organogram').default);
Vue.component('password-change', require('./Components/Views/Auth/PasswordChange').default);
Vue.component('social-links', require('./Components/Views/Auth/SocialLinks').default);
Vue.component('login', require('./Components/Views/Auth/Login').default);
Vue.component('password-reset', require('./Components/Views/Auth/PasswordReset').default);
Vue.component('reset-password', require('./Components/Views/Auth/ResetPassword').default);
Vue.component('registration', require('./Components/Views/Auth/Registration').default);
Vue.component('my-profile', require('./Components/Views/Auth/Profile').default);
Vue.component('questionnaire', require('./Components/Views/Auth/Questionnaire').default);
Vue.component('tasks', require('./Components/Views/Auth/Tasks').default);

//Company Service
Vue.component('company-services', require('./Components/Views/Auth/compnayinformation/Service/Index').default);
Vue.component('company-services-addmodal', require('./Components/Views/Auth/compnayinformation/Service/AddModal').default);


// Settings
Vue.component('app-setting', require('./Components/Views/Settings/Index').default);
Vue.component('general-setting', require('./Components/Views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./Components/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Components/Views/Settings/SmsSetting').default);
Vue.component('google-re-captcha-setting', require('./Components/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Components/Views/Settings/Notification/Settings/Index').default);
Vue.component('database-template', require('./Components/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Components/Views/Settings/Notification/Template/MailTemplate').default);
Vue.component('payment-method', require('./Components/Views/Settings/PaymentMethod/PaymentMethod').default);
Vue.component('payment-method-create-edit-modal', require('./Components/Views/Settings/PaymentMethod/PaymentMethodCreateEditModal').default);
Vue.component('email-header-footer-setting', require('./Components/Views/Settings/EmailHeaderFooter').default);
Vue.component('banking-detail-setting', require('./Components/Views/Settings/BankingDetail').default);

// User and Roles
Vue.component('user-roles', require('./Components/Views/UserRoles/Index').default);
Vue.component('employees', require('./Components/Views/Employees/Index').default);
Vue.component('group-of-users', require('./Components/Views/UserRoles/Roles/GroupOfUsers').default);
Vue.component('user-trainings', require('./Components/Views/UserTrainings/Index').default);
Vue.component('certificate-users', require('./Components/Views/UserTrainings/CertificateUsers').default);
Vue.component(
    "certificate-listing-modal",
    require("./Components/Views/UserTrainings/AddTrainingToUserModal").default
);
Vue.component(
    "training-request",
    require("./Components/Views/UserTrainings/TrainingRequest").default
);
Vue.component(
    "training-request-form-progress",
    require("./Components/Views/UserTrainings/RequestFormProgress").default
);

Vue.component('group-of-trainings', require('./Components/Views/UserTrainings/GroupOfTrainings').default);

// Layouts
Vue.component('app-top-bar', require('./Components/Views/Layouts/Nabar').default);
Vue.component('app-sidebar', require('./Components/Views/Layouts/Sidebar').default);

// Stripe 
Vue.component('app-stripe', require('./Components/Views/CustomFormBuilder/layouts/Stripe').default);

// notifications
Vue.component('all-notification', require('./Components/Views/Auth/Notification').default);
Vue.component('notification-view-modal', require('./Components/Views/Auth/NotificationViewModal').default);

Vue.component('re-captcha', require('./Components/Views/Auth/ReCaptcha').default);
Vue.component('payment-view', require('./Components/Views/Demo/Pages/PaymentMethodView').default);

// form builder layout
//Vue.component('app-right-sidebar', require('./Components/Views/CustomFormBuilder/Layouts/RightSidebar').default);
//
// Vue.component('CustomerManagementNavigator', require('./Components/Views/CustomerManagement/CustomerManagementNavigator').default);
